import { Button, Flex, Text } from '@chakra-ui/react';
import { useSubscriptionCache } from 'src/apollo/cache';
import { ShowsDocument, useRenewShowMutation } from 'src/generated/graphql';
import SubscriptionLockedNotice from 'src/pages/my-account/components/SubscriptionLockedNotice';
import useSubscriptionManagementLock from 'src/pages/my-account/utils/useSubscriptionManagementLock';
import assert from 'src/utils/assert';
import { useMyShowsContext } from './MyShowsContext';
import useGetExtraShowCost from './useGetExtraShowCost';

export default function RenewShow() {
  const { setContentType, showToRenew } = useMyShowsContext();
  assert(showToRenew, 'showToRenew is undefined');
  const { cost, currencySymbol } = useGetExtraShowCost();
  const [renewShow, { loading }] = useRenewShowMutation({
    onCompleted: () => {
      setContentType('show-renewed-confirmation');
    },
    variables: {
      id: showToRenew,
    },
    refetchQueries: [ShowsDocument],
  });
  const subscription = useSubscriptionCache();
  const { locked, reason } = useSubscriptionManagementLock(subscription);

  // Locked for PayPal-on-source customers (can't self-manage) and during the
  // payment-migration pause.
  if (locked) {
    return <SubscriptionLockedNotice reason={reason} />;
  }

  return (
    <>
      <Text>{`The subscription for this show will renew at ${currencySymbol}${cost}`}</Text>
      <Flex mt="20px" gap="10px">
        <Button loading={loading} onClick={() => renewShow()}>
          Renew
        </Button>
        <Button disabled={loading} visual="tertiary" onClick={() => setContentType('list-shows')}>
          Cancel
        </Button>
      </Flex>
    </>
  );
}
